import React from 'react';

const UserState = React.createContext([{ isLoggedIn: false }, () => {}]);

export default UserState;